"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAirwireResultToReview = convertAirwireResultToReview;
exports.sortAirwireProblems = sortAirwireProblems;
const shared_1 = require("@buildwithflux/shared");
const pcb_1 = require("../../pcb");
const reviews_1 = require("../../reviews");
const common_1 = require("./common");
function convertAirwireResultToReview(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const designators = problem.affectedItems
            .map((a) => {
            const componentUid = a.uid.split("_")[0] ?? "";
            const component = (0, common_1.getLabelForPcbNode)(nodes[componentUid]);
            const padNode = nodes[a.uid];
            let pinInfo;
            if (padNode?.type === pcb_1.PcbNodeTypes.pad) {
                const padBakedNode = padNode;
                const terminalId = padBakedNode.terminalId;
                const nodeLabel = (0, common_1.getLabelForPcbNode)(padNode);
                if (nodeLabel && nodeLabel.trim() !== "") {
                    pinInfo = nodeLabel;
                }
                else if (terminalId && terminalId.trim() !== "") {
                    pinInfo = terminalId;
                }
                else if (a.itemLabel && a.itemLabel.trim() !== "") {
                    pinInfo = a.itemLabel;
                }
                else {
                    pinInfo = a.uid.substring(0, 8);
                }
            }
            else {
                pinInfo = a.itemLabel ?? (0, common_1.getLabelForPcbNode)(padNode) ?? a.uid.substring(0, 8);
            }
            const designator = (0, common_1.sanitizeDesignator)(`${component}:${pinInfo}`);
            designatorUidMap[designator] = a.uid;
            return designator;
        })
            .join(", ");
        const net = problem.affectedItems[0]?.uid
            ? (0, common_1.sanitizeDesignator)((0, common_1.getNetNameForNode)(problem.affectedItems[0]?.uid, nodes))
            : null;
        if (net && problem.affectedItems[0]?.uid) {
            const netUid = (0, common_1.getNetUidForNode)(problem.affectedItems[0]?.uid, nodes);
            if (netUid) {
                designatorUidMap[net] = netUid;
            }
        }
        return { name: designators, designators, net, designatorUidMap };
    };
}
function sortAirwireProblems(problems, nodes) {
    const converter = convertAirwireResultToReview(nodes);
    const sortedProblems = [...problems].sort((a, b) => {
        const itemA = converter(a);
        const itemB = converter(b);
        const statusA = itemA.status ?? reviews_1.ReviewStatus.ERROR;
        const statusB = itemB.status ?? reviews_1.ReviewStatus.ERROR;
        const severityDiff = (reviews_1.priorityMap[statusB] ?? 0) - (reviews_1.priorityMap[statusA] ?? 0);
        if (severityDiff !== 0) {
            return severityDiff;
        }
        const netA = itemA.net ?? "zzz_none";
        const netB = itemB.net ?? "zzz_none";
        const netDiff = (0, shared_1.naturalSortByProperty)("net")({ net: netA }, { net: netB });
        if (netDiff !== 0) {
            return netDiff;
        }
        const designatorsA = itemA.designators ?? "zzz_none";
        const designatorsB = itemB.designators ?? "zzz_none";
        return (0, shared_1.naturalSortByProperty)("designators")({ designators: designatorsA }, { designators: designatorsB });
    });
    return { sortedProblems, converter };
}
//# sourceMappingURL=airwire.js.map